import type { UserBase } from 'models';
import { Card, Form } from 'ui';
import { MemberProgramsList } from './member-programs-list';
import { MemberProgramsListFilters, type MemberProgramsListFiltersFormValues } from './member-programs-list-filters';

type FormValues = MemberProgramsListFiltersFormValues;

type P = { getPathToProgramDetail: (id: string) => string; member: UserBase };

const MemberPrograms = ({ getPathToProgramDetail, member }: P) => (
  <Card>
    <Form<FormValues> noOptional>
      <MemberProgramsListFilters />
      <Form.Item<FormValues> dependencies={['search']} noStyle>
        {({ getFieldsValue }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          const { search } = getFieldsValue(true) as FormValues;

          return (
            <MemberProgramsList getPathToProgramDetail={getPathToProgramDetail} memberId={member.id} search={search} />
          );
        }}
      </Form.Item>
    </Form>
  </Card>
);
export default MemberPrograms;
